import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosApiInstance from '../../utils/apiClient';
import { endpoints } from '../config';

const initialState = {
  isSuccess: 'idle',
  isLoading: false,
  message: '',
};

export const fetchPermisosExportar = createAsyncThunk('reportePermisos/fetchPermisosExportar', async (data) => {
  const result = await axiosApiInstance({
    url: endpoints.permisos.reportePermisosExportar,
    method: 'POST',
    responseType: 'blob',
    data,
  }).then((response) => {
    // create file link in browser's memory
    const href = URL.createObjectURL(response.data);

    // create "a" HTML element with href to file & click
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', `Reporte de Permisos (${data.desde} - ${data.hasta}).pdf`); //or any other extension
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  });

  return result;
});

export const fetchPermisosExportarExcel = createAsyncThunk('reportePermisos/fetchPermisosExportarExcel', async (data) => {
  const result = await axiosApiInstance({
    url: endpoints.permisos.reportePermisosExportarExcel, //your url
    method: 'POST',
    responseType: 'blob',
    data,
  }).then((response) => {
    // create file link in browser's memory
    const href = URL.createObjectURL(response.data);

    // create "a" HTML element with href to file & click
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', `Reporte de Permisos (${data.desde} - ${data.hasta}).xls`); //or any other extension
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  });

  return result;
});

export const fetchCambiarSuccess = createAsyncThunk('reportePermisos/fetchCambiarSuccess', async () => {
  return null;
});

const ReportePermisosSlice = createSlice({
  name: 'reportePermisos',
  initialState,
  extraReducers(builder) {
    builder

      .addCase(fetchPermisosExportar.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = 'idle';
        state.message = '';
      })
      .addCase(fetchPermisosExportar.fulfilled, (state) => {
        state.isSuccess = 'success';
        state.message = '';
        state.isLoading = false;
      })
      .addCase(fetchPermisosExportar.rejected, (state, action) => {
        state.isSuccess = 'error';
        state.message = action.payload?.error.message;
        state.isLoading = false;
      })
      .addCase(fetchPermisosExportarExcel.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = 'idle';
        state.message = '';
      })
      .addCase(fetchPermisosExportarExcel.fulfilled, (state) => {
        state.isSuccess = 'success';
        state.message = '';
        state.isLoading = false;
      })
      .addCase(fetchPermisosExportarExcel.rejected, (state, action) => {
        state.isSuccess = 'error';
        state.message = action.payload?.error.message;
        state.isLoading = false;
      })
      .addCase(fetchCambiarSuccess.fulfilled, (state) => {
        state.isSuccess = 'idle';
      });
  },
});

export const selectIsLoading = (state) => state.reportePermisos.isLoading;
export const selectMessage = (state) => state.reportePermisos.message;
export const selectIsSuccess = (state) => state.reportePermisos.isSuccess;

export default ReportePermisosSlice.reducer;
